export default "__VITE_ASSET__311fcd59__"